import { Instance, SnapshotIn, types } from 'mobx-state-tree';

export interface SingleBarProps {
  x: number;
  y: number;
}

export const SingleBar = types.model({
  x: types.number,
  y: types.number,
});

export type SingleBarSnapshot = SnapshotIn<typeof SingleBar>;
export type SingleBarInstance = Instance<typeof SingleBar>;
